import React from "react";
import { Box, Typography } from "@mui/material";
import { getPrimaryColor } from "../GlobalFunction/Theme";

export default function MaintenancePage() {
  return (
    <Box
      sx={{
        minHeight: "100dvh",
        width: "100%",
        bgcolor: "#EFF4F0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 3, sm: 4, md: 6 },
        py: { xs: 5, md: 8 },
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 760,
          textAlign: "center",
        }}
      >
        <Box
          component="img"
          src="/img/Logo/SEHO-pro.webp"
          alt="SEHO PRO"
          sx={{
            width: { xs: 190, sm: 230, md: 270 },
            maxWidth: "70vw",
            height: "auto",
            display: "block",
            mx: "auto",
            mb: { xs: 5, md: 6 },
          }}
        />

        <Typography
          component="h1"
          sx={{
            color: getPrimaryColor("b2b"),
            fontWeight: 700,
            fontSize: { xs: 30, sm: 36, md: 44 },
            lineHeight: 1.3,
            mb: 1.5,
          }}
        >
          網站維護中
        </Typography>

        <Typography
          sx={{
            color: getPrimaryColor("b2b"),
            fontWeight: 600,
            fontSize: { xs: 15, sm: 17, md: 18 },
            letterSpacing: 1,
            mb: { xs: 4, md: 5 },
          }}
        >
          Website Under Maintenance
        </Typography>

        <Box
          sx={{
            width: 64,
            height: 2,
            bgcolor: getPrimaryColor("b2b"),
            mx: "auto",
            mb: { xs: 4, md: 5 },
          }}
        />

        <Typography
          sx={{
            color: "#333",
            fontSize: { xs: 16, sm: 18, md: 19 },
            lineHeight: 2,
            fontWeight: 400,
          }}
        >
          我們正在進行系統維護與更新，
          <br />
          網站將於完成後恢復正常服務。
        </Typography>

        <Typography
          sx={{
            color: "#555",
            fontSize: { xs: 14, sm: 16, md: 17 },
            lineHeight: 1.9,
            mt: 2,
          }}
        >
          造成不便，敬請見諒。
          <br />
          感謝您的耐心等候。
        </Typography>

        <Typography
          sx={{
            color: "#666",
            fontSize: { xs: 13, sm: 14, md: 15 },
            mt: { xs: 5, md: 6 },
          }}
        >
          台灣水禾實業有限公司
        </Typography>
      </Box>
    </Box>
  );
}